// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3KuvB","label":"Section_label__1K0xF","contentWrap":"Section_contentWrap__17Ya-","footer":"Section_footer__3iH7A","footerInner":"Section_footerInner__2Bs0c"};